function a(t, e) {
  return {
    id: t.id,
    name: t.filename,
    filename: t.filename,
    path: t.path,
    thumbnail: t.thumbnail || null,
    source: e,
    size: t.size,
    type: t.type,
    createdAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}
export {
  a as convertFileInfoToDataFile
};
